export const FETCH_OFFICES = "FETCH_OFFICES";
export const UPDATE_ALL = "UPDATE_ALL";
export const UPDATE_OFFICE_DETAILS = "UPDATE_OFFICE_DETAILS";
